import React, { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { signInWithGoogle } from "../../firebase/auth";
import UserContext from "../../context/user/UserContext";

function StartBtn() {
  const navigate = useNavigate();
  const location = useLocation();
  const userContext = useContext(UserContext);

  const handleBtnClick = () => {
    // If no user and if in home page
    if (userContext.user === null && location.pathname === "/")
      return signInWithGoogle();

    // If user and in home page
    if (location.pathname === "/") return navigate("/dashboard");

    // If user and not in home page
    navigate("/");
  };

  return (
    <button
      onClick={handleBtnClick}
      className="inline-block rounded-lg bg-indigo-500 px-4 py-3 text-center text-sm font-semibold text-white outline-none ring-indigo-300 transition duration-100 hover:bg-indigo-600 focus-visible:ring md:px-8 md:text-base"
    >
      {
        userContext.user === null
          ? location.pathname === "/" && "Start Now" // If no user and if in home page
          : location.pathname === "/"
          ? "Dashboard" // If user and in home page
          : "Home" // If user and not in home page
      }
    </button>
  );
}

export default StartBtn;
